module.exports = __webpack_public_path__ + "static/media/stock-incoming.245d3706.svg";